import axios from 'axios'

export let upload = (formData) => {
  const url = 'file/upload'
  return axios.post(url, formData)
  // get data
    .then(x => x.data)
    // add url field
    .then(x => x.map(img => Object.assign({},
      img, {url: img.SRC})))
}



// WEBPACK FOOTER //
// ./src/api/file.js